import { type ReactElement, type SVGProps } from 'react';

export const SurfaceTotalIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M13.854 1.854 12.707 3h3.086l1.854-1.854.707.708L17.207 3h3.086l1.354-1.354.707.708L21 3.707v3.086l1.146-1.147.708.708L21 8.207v3.086l1.146-1.146.708.707L21 12.707V17h-4.293l-1.853 1.854-.707-.707L15.293 17H13v-.793l-1.646 1.647-.707-.707L13 14.793v-3.086l-5.146 5.147-.708-.707L12.293 11H9.207l-2.853 2.854-.708-.707L7.793 11H7V8.707L5.854 9.854l-.708-.708L7 7.293V3h4.293l1.854-1.854.707.708ZM14 15.207V16h2.293L20 12.293V9.207l-6 6Zm6-7.414-6 6v-3.086l6-6v3.086ZM11.707 4h3.086l-6 6H8V7.707L11.707 4Zm1.586 6h-3.086l6-6h3.086l-6 6ZM8 4h2.293L8 6.293V4Zm9.707 12H20v-2.293L17.707 16ZM3.5 1.793 1.646 3.646l.708.708L3 3.707v13.086l-.646-.646-.708.707L3.5 18.708l1.854-1.854-.708-.707-.646.646V3.707l.646.647.708-.708L3.5 1.793ZM22.207 20.5l-1.853 1.854-.707-.707.646-.647H7.207l.647.646-.708.708L5.293 20.5l1.853-1.854.708.708-.647.646h13.086l-.646-.646.707-.707 1.854 1.853Z"
        clipRule="evenodd"
      />
    </svg>
  );
};
